/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitTag,
    PressKitTagFromJSON,
    PressKitTagFromJSONTyped,
    PressKitTagToJSON,
} from './PressKitTag';
import {
    PressKitThumbnailUrls,
    PressKitThumbnailUrlsFromJSON,
    PressKitThumbnailUrlsFromJSONTyped,
    PressKitThumbnailUrlsToJSON,
} from './PressKitThumbnailUrls';

/**
 * 
 * @export
 * @interface PressKitProfileListByCompanyIdResults
 */
export interface PressKitProfileListByCompanyIdResults {
    /**
     * PressKit Image UUID(v4)
     * @type {string}
     * @memberof PressKitProfileListByCompanyIdResults
     */
    id: string;
    /**
     * ファイル拡張子（原則英語小文字）
     * @type {string}
     * @memberof PressKitProfileListByCompanyIdResults
     */
    extension: PressKitProfileListByCompanyIdResultsExtensionEnum;
    /**
     * ファイルのサイズ（単位はbytes）
     * @type {number}
     * @memberof PressKitProfileListByCompanyIdResults
     */
    fileSize: number;
    /**
     * 企業が登録したプロフィールの役職
     * @type {string}
     * @memberof PressKitProfileListByCompanyIdResults
     */
    title: string;
    /**
     * 企業が登録したプロフィールの名前
     * @type {string}
     * @memberof PressKitProfileListByCompanyIdResults
     */
    name: string;
    /**
     * 企業が登録したプロフィールの名前のよみがな（発音)
     * @type {string}
     * @memberof PressKitProfileListByCompanyIdResults
     */
    nameKana: string;
    /**
     * 企業が登録したプロフィール文
     * @type {string}
     * @memberof PressKitProfileListByCompanyIdResults
     */
    description: string;
    /**
     * 
     * @type {PressKitThumbnailUrls}
     * @memberof PressKitProfileListByCompanyIdResults
     */
    thumbnailUrls: PressKitThumbnailUrls;
    /**
     * プロフィール画像のダウンロード用URL。別ドメイン。
     * @type {string}
     * @memberof PressKitProfileListByCompanyIdResults
     */
    downloadUrl: string;
    /**
     * ラスター画像の幅。単位はpx。ベクター画像はnull。
     * @type {number}
     * @memberof PressKitProfileListByCompanyIdResults
     */
    imageWidth: number;
    /**
     * ラスター画像の高さ。単位はpx。ベクター画像はnull。
     * @type {number}
     * @memberof PressKitProfileListByCompanyIdResults
     */
    imageHeight: number;
    /**
     * 企業が設定しているタグの一覧
     * @type {Array<PressKitTag>}
     * @memberof PressKitProfileListByCompanyIdResults
     */
    readonly tags: Array<PressKitTag>;
}

/**
* @export
* @enum {string}
*/
export enum PressKitProfileListByCompanyIdResultsExtensionEnum {
    Jpg = 'jpg',
    Png = 'png'
}

export function PressKitProfileListByCompanyIdResultsFromJSON(json: any): PressKitProfileListByCompanyIdResults {
    return PressKitProfileListByCompanyIdResultsFromJSONTyped(json, false);
}

export function PressKitProfileListByCompanyIdResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitProfileListByCompanyIdResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'extension': json['extension'],
        'fileSize': json['file_size'],
        'title': json['title'],
        'name': json['name'],
        'nameKana': json['name_kana'],
        'description': json['description'],
        'thumbnailUrls': PressKitThumbnailUrlsFromJSON(json['thumbnail_urls']),
        'downloadUrl': json['download_url'],
        'imageWidth': json['image_width'],
        'imageHeight': json['image_height'],
        'tags': ((json['tags'] as Array<any>).map(PressKitTagFromJSON)),
    };
}

export function PressKitProfileListByCompanyIdResultsToJSON(value?: PressKitProfileListByCompanyIdResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'extension': value.extension,
        'file_size': value.fileSize,
        'title': value.title,
        'name': value.name,
        'name_kana': value.nameKana,
        'description': value.description,
        'thumbnail_urls': PressKitThumbnailUrlsToJSON(value.thumbnailUrls),
        'download_url': value.downloadUrl,
        'image_width': value.imageWidth,
        'image_height': value.imageHeight,
    };
}

